import { z } from 'zod';
import { stockSummarySchema } from '../inventory/stock-summary.schema';
import { purchaseOrderSummarySchema } from '../procurement/purchase-order-summary.schema';
import { projectSummarySchema } from '../projects/project-summary.schema';
import { salesSummarySchema } from '../sales/sales-summary.schema';

/**
 * Kennzahlen des Analyse-Cockpits (`GET /v1/analytics/cockpit`, Recht
 * `analytics.read`) — serverseitig über ALLE Datensätze (2026-09-29). Vorher
 * rechnete der Browser über die erste Listenseite je Modul (Belege/Projekte/
 * Artikel 200, Bestellungen 100); Umsatz, Auftragsbestand, Trichter, Projekt-
 * Ampel, Lagerwert und Bestellvolumen waren danach falsch.
 *
 * Jeder Bereich braucht zusätzlich das Leserecht seines Moduls und ist sonst
 * `null` („für dich nicht freigegeben", nie „0"): `sales` = `sales.read`,
 * `projects` = `projects.read` (Auftragswerte darin wie in der Projektliste),
 * `purchasing` = `procurement.read`, `stock` = `inventory.read` (Werte darin nur
 * mit `inventory.viewprices`). Offene Posten stehen nicht hier — deren Liste ist
 * vollständig (`GET /v1/accounting/open-items`).
 */
export const analyticsCockpitSchema = z.object({
  asOf: z.string().datetime(),
  sales: salesSummarySchema.nullable(),
  projects: projectSummarySchema.nullable(),
  purchasing: purchaseOrderSummarySchema.nullable(),
  stock: stockSummarySchema.nullable(),
});
export type AnalyticsCockpit = z.infer<typeof analyticsCockpitSchema>;
